// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"9452e338","131":"e2bb748a","175":"d663f394","194":"6d1a703d","537":"879a4d8b","696":"5a371f21","848":"7009fc55","888":"2617c204","962":"86973a12"}[chunkId] + ".chunk.js";
};